import { useAuth } from "@tellescope/tanstack-query";
import { SidebarPanel } from "../components/SidebarPanel";

/**
 * Renders the app-shell sidebar only for authenticated users.
 *
 * The panel is mounted at the app shell (see Router.tsx) so it survives route navigation, which puts
 * it outside the per-route ProtectedRoute gate. Without this check its persisted open state would
 * make it appear on public routes (login, MFA, SSO completion), which have no app chrome.
 *
 * The condition matches the one `RouterContent` uses to decide a route may render authenticated
 * content, and every part of it is load-bearing. `isAuthenticated` alone is only
 * `!!authToken && !requiresMFA`, which is already true mid-bootstrap: a restored token satisfies it
 * before the session has settled, so the panel would mount and start fetching against a user and
 * organization it does not have yet, including over the public SSO hand-off.
 */
export const AuthenticatedSidebarPanel = () => {
  const { isAuthenticated, isInitializing, currentUser, selectedOrganization } = useAuth();

  if (!isAuthenticated || isInitializing || !currentUser || !selectedOrganization) return null;

  return <SidebarPanel />;
};
